import {Breadcrumbs, Box, Button} from '@deere/fuel-react';
import React from "react";
import {Link} from "react-router-dom";

export const AEBreadCrumbs = ({crumbs, currentPath}) => {
    return (
        <Box ml={{xs: 4, md: 0}} mb={0}>
            <Breadcrumbs>
                {crumbs.map(({name, path}, key) => path === currentPath ? "" : (
                        <Link
                            to={{
                                pathname: path,
                            }}
                            key={key}
                        >
                            <Button variant="text-inline">
                                {name}
                            </Button>
                        </Link>
                    )
                )}
            </Breadcrumbs>
        </Box>
    );
}
